import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';

// images
import appStoreImg from '../../assets/images/app-store.png';
import googlePlayImg from '../../assets/images/google-play.png';
import { currentBrandSelector, userDataSelector } from '../../helpers/selectors';
import * as PopupActions from '../../actions/popup';
import { connect } from 'react-redux';
import { links } from '../../constants/links';
import { showAppLegacyCompanyId } from '../../utils/utils';

export class MobileBanner extends Component {
  constructor(props) {
    super(props);
    this.bindFunctions();
  }

  bindFunctions() {
    this.handleAppStoreClick = this.handleAppStoreClick.bind(this);
    this.handlePlayStoreClick = this.handlePlayStoreClick.bind(this);
  }

  handleAppStoreClick() {
    const { userData } = this.props;
    
    if (userData && userData.company && userData.company.id) {
      const companyId = userData.company.id;
      const isLegacy = showAppLegacyCompanyId(companyId);
      const targetUrl = isLegacy ? links.legacyAppLinkApple : links.appStoreLink;
      window.open(targetUrl, '_blank');
    } else {
      this.props.popup_MobileAppSelector_SetVisibility(true, 'ios');
    }
  }

  handlePlayStoreClick() {
    const { userData } = this.props;
    
    if (userData && userData.company && userData.company.id) {
      const companyId = userData.company.id;
      const isLegacy = showAppLegacyCompanyId(companyId);
      const targetUrl = isLegacy ? links.legacyAppLinkPlay : links.playStoreLink;
      window.open(targetUrl, '_blank');
    } else {
      this.props.popup_MobileAppSelector_SetVisibility(true, 'android');
    }
  }

  render() {
    const { currentBrand, productName } = this.props;
    const { playStoreLink, appStoreLink, mobileBannerImage } = currentBrand || {};

    return (
      <div className="background-bg-dark" style={{ minHeight: '2px' }}>
        {(playStoreLink || appStoreLink) && (
          <div className="mobile-banner">
            {mobileBannerImage && (
              <div className="phone-image-container">
                <img alt="phone" className="phone-image" src={mobileBannerImage} />
              </div>
            )}
            <div className="download-app">
              <p className="title pt-15 pb-15 f-32 f-xs-26">
                <FormattedMessage id="mobile_banner.text" values={{ productName }} />
              </p>
              {appStoreLink && (
                <img 
                  src={appStoreImg} 
                  alt="App Store" 
                  className="mobile-store-img" 
                  onClick={this.handleAppStoreClick}
                  style={{ cursor: 'pointer' }}
                />
              )}
              {playStoreLink && (
                <img
                  src={googlePlayImg}
                  alt="Google Play"
                  className="mobile-store-img ml-10"
                  onClick={this.handlePlayStoreClick}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { 
    currentBrand: currentBrandSelector(state),
    userData: userDataSelector(state)
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...PopupActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileBanner);
